var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"flex-grow-1",class:{
    'secondary': !_vm.primary,
    'primary': _vm.primary
  },style:(_vm.cssProps),attrs:{"elevation":"0","x-large":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }